import ToolTip from "components/design/toolTip";
import { Button } from "components/DesignSystem/Button/Button";
import { CollapseNavIcon } from "components/icons/CollapseNavIcon";
import { ExpandNavIcon } from "components/icons/ExpandNavIcon";
import { ChatIcon } from "components/icons/LeftNav/ChatIcon";
import { LeftBarTag } from "components/Sidebar/LeftBar";
import { useChannelMessageCount } from "hooks/useChannelMessageCount";

export const SideChatControl = ({
  channelId,
  open,
  onOpenChange,
}: {
  channelId: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) => {
  const messageCount = useChannelMessageCount({ channelId });
  const isUnreadMessages =
    channelId &&
    Boolean(messageCount?.messages) &&
    (messageCount?.messages ?? 0) > 0;

  return (
    <div className="t-relative">
      <ToolTip text={open ? "Hide Chat" : "Show Chat"} side="bottom">
        <Button
          customType="ghost_icon"
          size="small"
          onClick={() => onOpenChange(!open)}
        >
          {isUnreadMessages && <ChatIcon size={20} />}
          {!isUnreadMessages && <CollapseNavIcon className="t-text-text-30" />}
          {isUnreadMessages && (
            <LeftBarTag
              type="blue"
              className="t-absolute t-top-0 t-right-0 t-transform t-translate-x-[35%] -t-translate-y-[30%] t-min-w-[1.5rem] t-text-center"
            >
              {(messageCount?.messages ?? 0) > 99
                ? "99+"
                : messageCount?.messages ?? 0}
            </LeftBarTag>
          )}
        </Button>
      </ToolTip>
    </div>
  );
};
